import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import Reveal from "../components/Reveal";
import { AREAS } from "../content/services";

export default function Servizi() {
  return (
    <>
      <Seo
        title="Servizi"
        description="Tutti i servizi di DN STUDIO TECNICO: catasto e DOCFA, conformità urbanistica e catastale, visure e verifiche immobiliari, successioni, APE e perizie, edilizia, sicurezza e siti web."
        path="/servizi"
      />
      <section className="bg-paper pb-12 pt-14 lg:pb-16 lg:pt-20" data-testid="page-servizi">
        <div className="container-site">
          <Reveal>
            <p className="eyebrow">Servizi</p>
            <h1 className="mt-4 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-antracite sm:text-4xl lg:text-5xl">
              Servizi tecnici per immobili, pratiche e documentazione
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted">
              Seguiamo le pratiche del tuo immobile in ogni fase: catasto, urbanistica, verifiche, documentazione e
              sicurezza. Ogni macroarea ha una pagina dedicata con tutto quello che occorre sapere.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 lg:pb-28" data-testid="servizi-catalogo">
        <div className="container-site">
          {AREAS.map((a, i) => (
            <Reveal key={a.id} delay={0.02 * i}>
              <div
                className={`grid gap-6 border-t border-line py-10 md:grid-cols-[0.8fr_1.2fr] md:gap-10 ${i === 0 ? "border-t-0" : ""}`}
                data-testid={`area-${a.id}`}
              >
                <div>
                  <h2 className="font-display text-xl font-bold text-antracite sm:text-2xl">{a.label}</h2>
                  {a.note && <p className="mt-2 text-xs leading-relaxed text-muted">{a.note}</p>}
                  <Link
                    to={a.path}
                    data-testid={`area-link-${a.id}`}
                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-petrolio transition-colors hover:text-petrolio-deep"
                  >
                    Pagina dedicata <ArrowRight size={15} />
                  </Link>
                  {a.also && (
                    <p className="mt-3 text-xs text-muted">
                      Vedi anche:{" "}
                      {a.also.map((x, j) => (
                        <span key={x.path}>
                          {j > 0 && " · "}
                          <Link to={x.path} className="font-medium text-petrolio underline underline-offset-2">
                            {x.label}
                          </Link>
                        </span>
                      ))}
                    </p>
                  )}
                </div>
                <ul className="flex flex-wrap content-start gap-2">
                  {a.services.map((s) => (
                    <li
                      key={s}
                      className="rounded-full border border-line bg-white px-4 py-2 text-xs text-antracite-soft sm:text-sm"
                    >
                      {s}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="border-t border-line bg-fog py-14">
        <div className="container-site flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
          <div>
            <h2 className="font-display text-xl font-bold text-antracite sm:text-2xl">Non sai quale pratica ti serve?</h2>
            <p className="mt-1.5 text-sm text-muted">Descrivi il tuo caso: la prima valutazione è gratuita.</p>
          </div>
          <Link to="/richiedi-valutazione" data-testid="servizi-cta" className="btn-primary whitespace-nowrap">
            Richiedi una valutazione gratuita
          </Link>
        </div>
      </section>
    </>
  );
}
